import { render, staticRenderFns } from "./CertSave.vue?vue&type=template&id=289938aa&scoped=true&"
import script from "./CertSave.vue?vue&type=script&lang=js&"
export * from "./CertSave.vue?vue&type=script&lang=js&"
import style0 from "./CertSave.vue?vue&type=style&index=0&id=289938aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289938aa",
  null
  
)

export default component.exports